import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

export const types = {
  TOGGLE_SIGNUP_POPUP_DIALOG: 'TOGGLE_SIGNUP_POPUP_DIALOG',

  TOGGLE_SIGNUP_TUTORIAL_DIALOG: 'TOGGLE_SIGNUP_TUTORIAL_DIALOG',
};

export const { toggleSignupPopupDialog, toggleSignupTutorialDialog } =
  createActions(
    types.TOGGLE_SIGNUP_POPUP_DIALOG,
    types.TOGGLE_SIGNUP_TUTORIAL_DIALOG
  );

const INIT_STATE = {
  isPopupOpen: false,
  isTutorialOpen: false,
};

const reducer = handleActions(
  {
    [types.TOGGLE_SIGNUP_POPUP_DIALOG]: (state) => ({
      ...state,
      isPopupOpen: !state.isPopupOpen,
    }),
    [types.TOGGLE_SIGNUP_TUTORIAL_DIALOG]: (state) => ({
      ...state,
      isTutorialOpen: !state.isTutorialOpen,
    }),
  },
  INIT_STATE
);

export default reducer;
export const getSignupDialog = (state) => state.signupDialog;
export const getSignupPopupDialogStatus = createSelector(
  getSignupDialog,
  (signupDialog) => signupDialog.isPopupOpen
);
export const getSignupTutorialDialogStatus = createSelector(
  getSignupDialog,
  (signupDialog) => signupDialog.isTutorialOpen
);



// WEBPACK FOOTER //
// ./src/services/redux/signupDialog.js